import {PHASES_OF_STAY} from '../constants';

const {ARRIVAL, DEPARTURE, PRE_ARRIVAL, STAY} = PHASES_OF_STAY;

export const ARRIVAL_BOT_TEXTS = {
    [ARRIVAL]: 'Get assistance for a hassle-free arrival. 🎉',
    [DEPARTURE]: 'Get support on questions related to your stay.',
    [PRE_ARRIVAL]:
        'We’re all set for your arrival! 🎉 Get help with questions related to your check-in.',
    [STAY]: 'Get support on questions related to your stay.',
};
